import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about" id="benefits">
      <div className="about-container">
        <span className="section-badge">BENEFITS</span>
        <h2 className="about-title">
          CLEVR: Your Smart Home Revolution in Sri Lanka
        </h2>
        <p className="about-text">
          Experience the future of living with CLEVR, Sri Lanka's leading smart home 
          automation provider. Our cutting-edge solutions, compatible with HomeKit, Alexa, 
          Matter, Google Assistant, and SmartThings, transform your home into a connected, 
          convenient, and secure haven. Enjoy seamless integration, reliable performance, 
          and personalized control.
        </p>
      </div>
    </section>
  );
};

export default About;
